import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import Form, { ButtonItem, SimpleItem, EmptyItem, GroupItem, ColCountByScreen, Label } from 'devextreme-react/form'
import { useMediaQuery } from '@mui/material'

const PaymentsViewForm = ({ payment }) => {
    const navigate = useNavigate()
    const [labelLocation, setLabelLocation] = useState('left')
    const sm = useMediaQuery('(max-width:600px)')

    useEffect(() => {
        setLabelLocation(sm ? 'top' : 'left')
    }, [sm])

    const cancelButtonOptions = {
        text: 'Cancel',
        type: 'Normal',
        width: 120,
        onClick: () =>
            navigate('/registrations/payments', {
                state: { navigateFrom: 'cancel-detail-payments' },
            }),
    }

    return (
        <React.Fragment>
            <form>
                <Form
                    mode='form'
                    labelLocation={labelLocation}
                    formData={payment}
                    showColonAfterLabel={false}
                    showValidationSummary={false}
                    readOnly={true}>
                    <GroupItem cssClass='form-group-item' caption='Payment Details'>
                        <ColCountByScreen lg={13} md={1} sm={1} xs={1} />
                        <GroupItem />
                        <GroupItem />
                        <GroupItem />
                        <GroupItem cssClass='form-group-item' colSpan={6}>
                            <EmptyItem />
                            <SimpleItem
                                dataField='datePayment'
                                editorType='dxDateBox'
                                editorOptions={{
                                    displayFormat: 'shortDateShortTime',
                                    type: 'datetime',
                                    pickerType: 'calendar',
                                    useMaskBehavior: true,
                                }}>
                                <Label text='Payment Date' />
                            </SimpleItem>
                            <SimpleItem dataField='firstName'>
                                <Label text='Customer First Name,' />
                            </SimpleItem>
                            <SimpleItem dataField='lastName'>
                                <Label text='Customer Last Name,' />
                            </SimpleItem>
                            <SimpleItem dataField='familyName'>
                                <Label text='Family Name,' />
                            </SimpleItem>
                            <SimpleItem dataField='paymentAmount' editorType='dxNumberBox'>
                                <Label text='Payment Amount' />
                            </SimpleItem>
                        </GroupItem>
                    </GroupItem>
                    <EmptyItem />
                    <GroupItem>
                        <ColCountByScreen lg={2} md={2} sm={2} xs={2} />
                        <ButtonItem buttonOptions={cancelButtonOptions} horizontalAlignment='right' />
                    </GroupItem>
                    <EmptyItem />
                </Form>
            </form>
        </React.Fragment>
    )
}

export default PaymentsViewForm
